import { render, staticRenderFns } from "./HeaderProdutoGrupo.vue?vue&type=template&id=65976b63&scoped=true"
import script from "./HeaderProdutoGrupo.vue?vue&type=script&lang=js"
export * from "./HeaderProdutoGrupo.vue?vue&type=script&lang=js"
import style0 from "./HeaderProdutoGrupo.vue?vue&type=style&index=0&id=65976b63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65976b63",
  null
  
)

export default component.exports